import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { WHATSAPP_CHAT_URL } from '@/data/contact';
import { track } from '@/helpers/analytics';

interface WhatsAppButtonProps {
    location: string;
    label?: string;
    variant?: 'solid' | 'outline';
    size?: 'md' | 'sm';
    className?: string;
}

const WhatsAppButton: React.FC<WhatsAppButtonProps> = ({
    location,
    label = 'Hilfe per WhatsApp',
    variant = 'solid',
    size = 'md',
    className = '',
}) => {
    const sizeClass = size === 'sm' ? 'px-4 py-1.5 text-sm' : 'px-5 py-2.5';
    const style = variant === 'solid'
        ? 'border-2 border-primary bg-primary text-textColor hover:border-primaryDark hover:bg-primaryDark'
        : 'border-2 border-primary text-textColor hover:bg-primaryLight';

    return (
        <a
            href={WHATSAPP_CHAT_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => track('whatsapp-click', { location })}
            className={`inline-flex items-center justify-center gap-2 rounded-full font-semibold ${sizeClass} transition ${style} ${className}`}
        >
            <FaWhatsapp className={`${size === 'sm' ? 'h-4 w-4' : 'h-5 w-5'} flex-shrink-0`} aria-hidden="true" />
            {label}
        </a>
    );
};

export default WhatsAppButton;
